export const baseHeaders = {
  "x-device-platform": "web",
  "x-app-version": "1",
  "x-app-version-code": "1",
}

export const API_BASE_URL = process.env.NEXT_PUBLIC_NELO_API_BASE_URL || "http://localhost:9000"
// Sandbox api-v2 base URL. In sandbox mode the whole nelo api-v2 surface (auth, IDV, loan) routes
// here so it runs against the isolated sandbox env. Empty until the host lands, so it stays inert.
export const NEXT_PUBLIC_NELO_API_BASE_URL_SANDBOX: string | undefined = process.env.NEXT_PUBLIC_NELO_API_BASE_URL_SANDBOX || undefined
// URL.hostname strips the brackets from an IPv6 literal, so both forms are listed.
const LOOPBACK_HOSTS = new Set(["localhost", "127.0.0.1", "::1", "[::1]"])

export const isLoopbackUrl = (url: string): boolean => {
  try {
    return LOOPBACK_HOSTS.has(new URL(url).hostname)
  } catch {
    return false
  }
}

// Host serving the hosted checkout UI in sandbox mode (the API host is the value above).
export const SANDBOX_HOST = "checkout-sandbox.nelo.co"

export const PSEUDO_ID_COOKIE = "pseudo_id"
export const DEVICE_ID_COOKIE = "nelo_device_id"
export const DEVICE_ID_MAX_AGE_SECONDS = 60 * 60 * 24 * 365 * 2
export const NELO_VISIT_ID_COOKIE = "nelo_visit_id"
export const NELO_VISIT_USER_COOKIE = "nelo_visit_user"
export const VISIT_ID_MAX_AGE_SECONDS = 30 * 60
export const VISIT_ID_HEADER = "x-nelo-visit-id"
export const CLIENT_HOST_HEADER = "x-nelo-client-host"
export const CLIENT_HOST_WEB = "web"
export const CLIENT_HOST_APP_WEBVIEW = "app_webview"
export const AUTH_TOKEN_COOKIE = "nelo_auth_token"
export const ADMIN_AUTH_TOKEN_COOKIE = "nelo_admin_token"
export const POST_CHECKOUT_SEEN_COOKIE = "nelo_post_checkout_seen"
export const POST_CHECKOUT_SEEN_MAX_AGE_SECONDS = 60 * 60 * 24 * 365 * 10
export const PSEUDO_ID_HEADER = "x-user-pseudo-id"
export const PSEUDO_ID_HEADER_LEGACY = "user-uuid"
export const UTM_PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "utm_ad", "utm_id"]
export const FBP_COOKIE = "_fbp"
export const FBC_COOKIE = "_fbc"
export const FBCLID_PARAM = "fbclid"
export const META_FBP_HEADER = "X-Meta-Fbp"
export const META_FBC_HEADER = "X-Meta-Fbc"
export const META_EVENT_SOURCE_URL_HEADER = "X-Meta-Event-Source-Url"
export const NELO_CONVERSION_ID_HEADER = "X-Nelo-Conversion-Id"

export const BEST_SELLERS_COLLECTION_HANDLE = "los-mas-vendidos"

export const NEXT_PUBLIC_EVENTS_BASE_URL = process.env.NEXT_PUBLIC_EVENTS_BASE_URL || "https://impressions.nelo.co"
export const NEXT_PUBLIC_EVENTS_BASE_URL_SANDBOX: string | undefined = process.env.NEXT_PUBLIC_EVENTS_BASE_URL_SANDBOX || undefined
